export const TANQUE_BEBEDOURO = {
    Codigo: 18,
    Nome: 'Tanque Bebedouro',
    Capa: null, 
    Home: true,
    Imagens: [
        {
            Capa: true,
            Ativo: true,
            Url: "assets/IPB/Produtos/Tanque_Bebedouro/tanque_1.png"
        }
        , {
            Url: "assets/IPB/Produtos/Tanque_Bebedouro/tanque_2.png"
        }
        , {
            Url: "assets/IPB/Produtos/Tanque_Bebedouro/tanque_3.jpg"
        }
    ],
    Detalhes: [
        `02 Bebedouros 100L`,
        `Boia/Torneira automática`,
        `Alta vazão`,
        `Revestimento em Epoxi Sanitário`,
        `3000L ou 4500L`,
    ],
    Modelos: [
        { Modelo: '3000', Detalhes:	'3000 litros' },
        { Modelo: '4500', Detalhes:	'4500 litros' }
    ]
}